import React from "react";
import { Card, Dropdown, Spinner } from "react-bootstrap";
import { format } from "date-fns";
import { DATE_FORMAT, NOTES_STATUS } from "configurations/Constants";

const NoteCard = ({
  note,
  resolvingNoteId,
  handleResolveNote,
  handleDeleteNote,
}) => {
  return (
    <Card key={note.id} className="my-3 mx-2 border shadow-sm">
      <Card.Body className="p-2">
        <div className="d-flex justify-content-between mb-2">
          <small>{note.content}</small>
          <div className={`note-status ${note.status.toLowerCase()}`}>
            {resolvingNoteId === note.id ? (
              <div className="d-flex align-items-center gap-2">
                Resolving{" "}
                <Spinner
                  animation="border"
                  size="sm"
                  className="note-status-spinner"
                />
              </div>
            ) : (
              note.status
            )}
          </div>
        </div>

        <div>
          {note.tags && note.tags.length > 0 && (
            <div className="note-tags">
              {note.tags.map((tag, index) => (
                <span key={tag.id || index}>{tag.name}</span>
              ))}
            </div>
          )}
        </div>

        <div className="d-flex gap-2 align-items-end justify-content-end">
          <div className="note-date">
            {note.authorName} -{" "}
            {format(new Date(note.created), `${DATE_FORMAT} HH:mm`)}
          </div>
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="outline-dark"
              className="no-caret"
              size="sm"
              disabled={resolvingNoteId === note.id}
            >
              <i className="fa fa-ellipsis-h"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ minWidth: "fit-content" }}>
              {note.status === NOTES_STATUS.PENDING && (
                <Dropdown.Item onClick={() => handleResolveNote(note.id)}>
                  <i className="fa-solid fa-circle-check me-2"></i>
                  Resolve
                </Dropdown.Item>
              )}
              <Dropdown.Item onClick={() => handleDeleteNote(note.id)}>
                <i className="fa fa-trash me-2"></i> Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Card.Body>
    </Card>
  );
};

export default NoteCard;
